module.exports = __webpack_public_path__ + "static/assets/a2bf4b67c31465785acd31bbdadbcc9c.png";